<div class="content-container" *ngIf="ready">
    <h3>{{title}}</h3>

    <div *ngFor="let tab of tabs">
        <h4>{{getTitleOfTab(tab)}}</h4>
        <p [innerHTML]="getContentOfTab(tab)"></p>
    </div>
</div>
